import Gallery from 'components/Gallery/Gallery';
import withCountry from 'enhancers/withCountry';
import withGalleryPageQuery, { WithGalleryPageQueryProps } from 'enhancers/withGalleryPageQuery';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import withWindowState, { WithWindowState } from 'enhancers/withWindowState';
import * as React from 'react';
import styled from 'styled-components';
import { getTextColor } from 'utils/colors';

type Props = WithGalleryPageQueryProps & WithWindowState & WithLanguageProps;

export const GalleryPage: React.SFC<Props> = props => {
  const backgroundColor =
    !props.loading && props.data && props.data.fetch.Common.Gallery
      ? props.data.fetch.Common.Gallery.BackgroundColor
      : '#ffffff';
  const color = getTextColor(backgroundColor);
  return (
    <Container style={{ backgroundColor, color }} color={color}>
      {!props.loading &&
      props.data &&
      props.data.fetch.Country.AboutPage &&
      props.data.fetch.Country.AboutPage.GalleryPage &&
      props.data.fetch.Country.AboutPage.GalleryPage.Carousels
        ? props.data.fetch.Country.AboutPage.GalleryPage.Carousels.map(
            carousel => {
              return (
                <Section key={carousel._meta.id}>
                  <Title style={{ color }}>
                    {props.getText(carousel.Title)}
                  </Title>
                  {carousel.Images && (
                    <GallerySection
                      maxHeight="600px"
                      images={carousel.Images.map(item => item.Image)}
                      lightbox={true}
                    />
                  )}
                </Section>
              );
            }
          )
        : []}
    </Container>
  );
};

const Section = styled.div`
  padding-bottom: 40px;
`;

const Title = styled.h3`
  text-align: center;
  font-size: 30px;
`;

const Container = styled.div<{ color: string }>`
  padding-top: 25px;
  overflow: hidden;
  .slick-next:before,
  .slick-prev:before {
    color: black;
  }
`;

const GallerySection = styled(Gallery)`
  button {
    color: #000;
    &:hover {
      color: #fff;
    }
  }
`;

export default withLanguageState(
  withWindowState(withCountry(withGalleryPageQuery(GalleryPage)))
);



// WEBPACK FOOTER //
// ./src/pages/GalleryPage/GalleryPage.tsx